import { AuthFormFields } from "@aws-amplify/ui";

export const authFormFields: AuthFormFields = {
  signIn: {
    username: {
      labelHidden: false,
      placeholder: "Enter",
      isRequired: true,
    },
    password: {
      labelHidden: false,
      placeholder: "Password",
      isRequired: true,
    },
  },
  signUp: {
    given_name: { order: 1, placeholder: "Enter", label: "First Name", labelHidden: false, isRequired: true },
    family_name: { order: 2, placeholder: "Enter", label: "Last Name", labelHidden: false, isRequired: true },
    email: { order: 3, placeholder: "Enter", labelHidden: false, isRequired: true },
    username: { order: 4, placeholder: "Enter", labelHidden: false, isRequired: true },
    password: { order: 5, placeholder: "Password", labelHidden: false, isRequired: true },
    confirm_password: { order: 6, placeholder: "Password", labelHidden: false, isRequired: true },
  },
  confirmSignUp: {
    confirmation_code: { placeholder: "Enter", label: "Confirmation Code", labelHidden: false, isRequired: true },
  },
  resetPassword: {
    username: {
      labelHidden: false,
      label: "Username or Email",
      placeholder: "Enter",
      isRequired: true,
    },
  },
  confirmResetPassword: {
    confirmation_code: {
      labelHidden: false,
      label: "Confirmation Code",
      placeholder: "Enter",
      isRequired: true,
    },
    password: {
      labelHidden: false,
      label: "New Password",
      placeholder: "Password",
      isRequired: true,
    },
    confirm_password: {
      labelHidden: false,
      label: "Confirm New Password",
      placeholder: "Password",
      isRequired: true,
    },
  },
  forceNewPassword: {
    password: {
      labelHidden: false,
      label: "New Password",
      placeholder: "Password",
      isRequired: true,
    },
    confirm_password: {
      labelHidden: false,
      label: "Confirm New Password",
      placeholder: "Password",
      isRequired: true,
    },
  },
};
